import React, { useState, useEffect } from 'react';
import TourItem from './tourItem';
import { Checkbox } from 'antd';

const CheckboxGroup = Checkbox.Group;

export const MultiDayTourItem = (props) => {
    const { item, defaultCheckedList, checkedList, setCheckedList, deleteAvailable } = props;
    const [checkedListParts, setCheckedListParts] = useState([]);
    const [className, setClassName] = useState('unactive');

    useEffect(() => {
        if (defaultCheckedList) {
            defaultCheckedList.map(check => {
                item.parts.map(part => {
                    const data = [];
                    if (check === +part.id) {
                        data.push(part);
                    }
                    setClass(data);
                    setCheckedListParts(data);
                })
            })
        }
        return () => {
            setClassName('unactive');
            setCheckedListParts([]);
        }
    }, [])

    useEffect(() => {
        const data = [];
        checkedList.map(check => {
            item.parts.map(part => {
                if (check === +part.id) {
                    data.push(part);
                }
            })
        })
        setClass(data);
    }, [checkedList]);

    const setClass = (data) => {
        if (data.length === item.parts.length) {
            setClassName('active');
        } else if (data.length < item.parts.length && data.length !== 0) {
            setClassName('indeterminate');
        } else {
            setClassName('unactive');
        }
    }

    const onCheckAllChange = () => {
        const data = item.parts.map(part => +part.id);
        if (className === 'unactive') {
            setCheckedList([...checkedList, ...data]);
            setClassName('active');
        } else {
            setCheckedList(checkedList.filter(item => !data.includes(item)));
            setClassName('unactive');
        }
    };


    const onChange = target => {
        const data = checkedListParts;
        if (data.includes(target)) {
            const index = data.indexOf(target);
            data.splice(index, 1);
        } else {
            data.push(target);
        }
        setClass(data);
        setCheckedListParts(data);
    };

    return item.parts ? (
        <div>
            <div className={`multiDayTourTitleLayout ${className}`} onClick={() => onCheckAllChange()}>
                <div className={`multiDayTourTitle ${className}`}></div>
                <TourItem item={item} deleteAvailable={deleteAvailable} isLinkEnabled {...props} key={item.id} />
            </div>
            <div style={{ marginLeft: 20 }}>
                {item.parts.map(part => (
                    <Checkbox value={+part.id} key={+part.id} onChange={(e) => onChange(e.target.value)}>
                        {part.title}
                    </Checkbox>
                ))}
            </div>
        </div >
    ) : null
}
